import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS } from '@utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};

export default {
    name: 'VocItemSuggestionsForSingleItemAgg',
    productArea: VOC,
    responseFormat: 'rows',
    build: ({ type = 'idea', vocItemId }) => {
        const idField = type === 'idea' ? 'leftId' : 'rightId';

        const pipeline = o.pipeline(
            o.sources.suggestions({
                state: 'pending',
                type: 'ideaAndFeedbackItem',
            }),
            o.filter(`${idField} == "${vocItemId}"`),
            o.sort('-score'),
            o.limit(10),
        );

        return pipeline;
    },
};
